/* eslint no-use-before-define: 0 */ // --> OFF
// prettier-ignore
const Produce = {
	"apples": {
		"name": "apples",
		"seasons": [
			9,
			10,
			11
		],
		"preparations": [
			1, 2, 3, 4, 5, 6
		],
		"pairings": [
			"allspice",
			"almonds",
			"bacon",
			"bay leaf",
			"beef",
			"blackberries",
			"bourbon",
			"brandy",
			"butter",
			"cabbage",
			"caramel",
			"cardamom",
			"celery",
			"celery root",
			"cheese",
			"cherries",
			"chestnuts",
			"chicken",
			"chives",
			"cinnamon",
			"cloves",
			"cognac",
			"coriander",
			"cranberries",
			"creme fraiche",
			"currants",
			"curry powder",
			"dates",
			"duck",
			"eggplant",
			"fennel",
			"frisee",
			"ginger",
			"hazelnuts",
			"honey",
			"horseradish",
			"lemon",
			"thyme",
			"mustard",
			"nutmeg",
			"nuts",
			"oatmeal and oats",
			"onions",
			"orange",
			"parsley",
			"peanuts and peanut butter",
			"pears",
			"pecans",
			"pepper",
			"pies",
			"pineapple",
			"pine nuts",
			"pistachios",
			"plums",
			"pomegranates",
			"pork",
			"poultry",
			"prunes",
			"pumpkin",
			"rhubarb",
			"rice and rice pudding",
			"rosemary",
			"sauerkraut",
			"sherry",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": [
			"apricots",
			""
		],
		"great pairings": null,
		"isFruit": 1
	},
	"apricots": {
		"name": "apricots",
		"seasons": [
			5,
			6,
			7,
			8
		],
		"preparations": [
			1, 2, 4, 5
		],
		"pairings": [
			"allispice",
			"cherries",
			"cinnamon",
			"currants",
			"custard",
			"french toast",
			"ginger",
			"hazelnuts",
			"honey",
			"ice cream",
			"lemon juice",
			"madeira",
			"moroccan cuisine",
			"orange",
			"pancakes / crepes",
			"pistachios",
			"pork",
			"prunes",
			"pumpkin seeds",
			"raisins",
			"rice pudding",
			"sugar",
			"tamarind paste",
			"vanilla",
			"wine",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"artichokes": {
		"name": "artichokes",
		"seasons": [
			4,
			5,
			6,
			7,
			8
		],
		"preparations": [
			1, 2, 3, 4, 5, 6, 7
		],
		"pairings": [
			"aioli",
			"anchovies",
			"arugula",
			"bacon",
			"basil",
			"bay leaf",
			"fava beans",
			"beets",
			"bell peppers",
			"bread crumbs",
			"butter",
			"capers",
			"carrots",
			"cashews",
			"celery",
			"chicken",
			"chives",
			"coriander",
			"cream",
			"creme fraiche",
			"garlic",
			"grapefruit",
			"ham",
			"hazelnuts",
			"hollandaise sauce",
			"leeks",
			"lemon",
			"mayonnaise",
			"mint",
			"mushrooms",
			"mustard",
			"nuts",
			"olive oil",
			"olives",
			"onions",
			"orange",
			"pancetta",
			"parsley",
			"pepper",
			"pesto",
			"prosciutto",
			"radicchio",
			"shallots",
			"shellfish",
			"sherry",
			"spinach",
			"tapenade",
			"tarragon",
			"thyme",
			"tomatoes",
			"truffles",
			"vinaigrette",
			"white wine",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"arugula": {
		"name": "arugula",
		"seasons": [
			6,
			7,
			8
		],
		"preparations": [
			1, 5, 6
		],
		"pairings": [
			"almonds",
			"basil",
			"bell peppers",
			"cheese",
			"chicken",
			"cilantro",
			"clams",
			"corn",
			"cucumbers",
			"dill",
			"hard boiled eggs",
			"endive",
			"fennel",
			"fish",
			"garlic",
			"grapes",
			"lemon juice",
			"mint",
			"mushrooms",
			"mussels",
			"nuts",
			"olive oil",
			"olives",
			"oranges",
			"pancetta",
			"parsley",
			"pasta",
			"pears",
			"pesto",
			"pine nuts",
			"potatoes",
			"prosciutto",
			"radicchio",
			"radishes",
			"sunchokes",
			"vinigrette",
			"watercress",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"asparagus": {
		"name": "asparagus",
		"seasons": [
			4,
			5,
			6
		],
		"preparations": [
			1, 3, 4, 2, 7, 6
		],
		"pairings": [
			"almonds",
			"anchovies",
			"artichokes",
			"basil",
			"bay leaf",
			"beets",
			"bread crumbs",
			"brown butter",
			"capers",
			"caraway seeds",
			"carrots",
			"cayenne",
			"cheese",
			"dill",
			"garlic",
			"ham",
			"hollandaise sauce",
			"leeks",
			"lemon",
			"lime",
			"lobster",
			"marsala wine",
			"mayonnaise",
			"mushrooms",
			"mustard",
			"olive oil",
			"orange",
			"oysters",
			"pancetta",
			"parsley",
			"pasta",
			"peas",
			"black pepper",
			"peppers",
			"potatoes",
			"pistachios",
			"prosciutto",
			"ramps",
			"risotto",
			"saffron",
			"sage",
			"salmon",
			"scallions",
			"sesame seeds",
			"shallots",
			"shrimp",
			"sour cream",
			"spinach",
			"tarragon",
			"thyme",
			"tomatoes",
			"turnips",
			"vermouth",
			"vinaigrette",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"avocado": {
		"name": "avocado",
		"seasons": [
			4,
			5
		],
		"preparations": [
			5
		],
		"pairings": [
			"arugula",
			"bacon",
			"basil",
			"black beans",
			"bell peppers",
			"chayote",
			"chervil",
			"chicken",
			"chile peppers",
			"chives",
			"cilantro",
			"corn and masa",
			"crab",
			"heavy cream",
			"creme fraiche",
			"cucumbers",
			"cumin",
			"dashi",
			"endive",
			"fennel",
			"fish",
			"frisee",
			"tropical fruits",
			"garlic",
			"grapefruit",
			"jicama",
			"lemon",
			"lime juice",
			"lobster",
			"mango",
			"mayonnalse",
			"canola oil",
			"onions",
			"orange",
			"parsley",
			"black pepper",
			"radishes",
			"rocket",
			"sake",
			"scallions",
			"spinach",
			"tarragon",
			"tequila",
			"tomatillos",
			"tomatoes",
			"vinaigrette",
			"tarragon",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"beets": {
		"name": "beets",
		"seasons": [
			7,
			8,
			9,
			10
		],
		"preparations": [
			1, 2, 7
		],
		"pairings": [
			"apples",
			"arugula",
			"avocado",
			"basil",
			"green beans",
			"beef",
			"beet greens",
			"butter",
			"cabbage",
			"capers",
			"caraway seeds",
			"carrots",
			"caviar",
			"celery",
			"chervil",
			"chicory",
			"chiles",
			"chives",
			"cilantro",
			"citrus",
			"coriander",
			"cream",
			"creme fraiche",
			"cumin",
			"curry",
			"dill",
			"endive",
			"escarole",
			"fennel",
			"fennel seeds",
			"fish",
			"frisee",
			"garlic",
			"ginger",
			"herbs",
			"honey",
			"herring",
			"horseradish",
			"leeks",
			"lemon",
			"lime",
			"maple syrup",
			"mint",
			"mushrooms",
			"mustard",
			"mustard oil",
			"nutmeg",
			"olives",
			"olive oil",
			"onions",
			"orange",
			"parsley",
			"pasta",
			"pears",
			"black pepper",
			"pistachios",
			"radishes",
			"rosemary",
			"scallions",
			"shallots",
			"sherry",
			"sour cream",
			"spinach",
			"sugar",
			"tarragon",
			"thyme",
			"vinaigrette",
			"vodka",
			"walnuts",
			"walnut oil",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"bell peppers": {
		"name": "bell peppers",
		"seasons": [
			6,
			7,
			8,
			9,
			10,
			11
		],
		"preparations": [
			2, 4, 5, 6, 7
		],
		"pairings": [
			"anchovies",
			"anise",
			"arugula",
			"bacon",
			"basil",
			"bay leaf",
			"beef",
			"butter",
			"capers",
			"cardamom",
			"carrots",
			"cayenne",
			"cheese",
			"chives",
			"cilantro",
			"coriander",
			"cream",
			"cumin",
			"curry",
			"eggplant",
			"fennel",
			"fennel seeds",
			"game",
			"garlic",
			"ginger",
			"hazelnuts",
			"honey",
			"lamb",
			"lomon",
			"lemongrass",
			"lime",
			"marjoram",
			"mint",
			"mushrooms",
			"mustard",
			"olive oil",
			"olives",
			"onions",
			"oregano",
			"parsley",
			"pasta",
			"peas",
			"pine nuts",
			"polenta",
			"pork",
			"quail",
			"red pepper flakes",
			"rice",
			"rosemary",
			"saffron",
			"sausages",
			"scallions",
			"sea bass",
			"sesame oil",
			"shallots",
			"smoked paprika",
			"squash",
			"stews",
			"swordfish",
			"thyme",
			"tomatoes",
			"tuna",
			"watercress",
			"zucchini",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"blackberries": {
		"name": "blackberries",
		"seasons": [
			7,
			8
		],
		"preparations": [
			2, 5
		],
		"pairings": [
			"almonds",
			"apples",
			"apricots",
			"bananas",
			"blueberries",
			"brandy",
			"butter",
			"buttermilk",
			"caramel",
			"chocolate",
			"cinnamon",
			"cloves",
			"cream and ice cream",
			"cream cheese",
			"creme de cassis",
			"creme fraiche",
			"custard",
			"ginger",
			"goat cheese",
			"hazelnuts",
			"honey",
			"lemon juice",
			"lime",
			"mango",
			"mascarpone",
			"melons",
			"mint",
			"nectarines",
			"oats",
			"oranges",
			"peaches",
			"pork",
			"raspberries",
			"sour cream",
			"strawberries",
			"vanilla",
			"watermelon",
			"wine",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"blueberries": {
		"name": "blueberries",
		"seasons": [
			6,
			7,
			8
		],
		"preparations": [
			2, 5
		],
		"pairings": [
			"allspice",
			"almonds",
			"apples",
			"apricots",
			"bananas",
			"blackberries",
			"butter",
			"buttermilk",
			"chocolate",
			"cinnamon",
			"cloves",
			"cognac",
			"cream and ice cream",
			"cream cheese",
			"creme fraiche",
			"custard",
			"ginger",
			"honey",
			"lemon",
			"lime",
			"mace",
			"mango",
			"maple syrup",
			"mascarpone",
			"melon",
			"mint",
			"molasses",
			"nectarines",
			"nutmeg",
			"oats and oatmeal",
			"orange",
			"peaches",
			"pears",
			"pies",
			"pineapple",
			"pine nuts",
			"port",
			"raspberries",
			"rhubarb",
			"ricotta cheese",
			"sour cream",
			"strawberries",
			"sugar",
			"vanilla",
			"walnuts",
			"watermelon",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"broccoli": {
		"name": "broccoli",
		"seasons": [
			1,
			2,
			3,
			4,
			5,
			11,
			12
		],
		"preparations": [
			1, 3, 6, 7
		],
		"pairings": [
			"almonds",
			"anchovies",
			"basil",
			"bread crumbs",
			"butter",
			"caraway seeds",
			"carrots",
			"cauliflower",
			"cheese",
			"chicken",
			"chile peppers",
			"cilantro",
			"coriander",
			"cream",
			"curry",
			"eggs",
			"garlic",
			"ginger",
			"hollandaise sauce",
			"lemon juice",
			"mint",
			"mustard",
			"olive oil",
			"olives",
			"onions",
			"oregano",
			"parsley",
			"pasta",
			"red pepper flakes",
			"rice",
			"scallions",
			"shallots",
			"tarragon",
			"thyme",
			"vinaigrette",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"broccolini": {
		"name": "broccolini",
		"seasons": [
			1,
			2,
			3,
			10,
			11,
			12
		],
		"preparations": [
			1, 5, 6, 7
		],
		"pairings": [
			"almonds",
			"basil",
			"cheese",
			"garlic",
			"lemon juice",
			"olive oil",
			"parsley",
			"pasta",
			"red pepper flakes",
			"salads",
			"sesame oil",
			"soups",
			"tomatoes",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"brussels sprouts": {
		"name": "brussels sprouts",
		"seasons": [
			10,
			11,
			12,
			1,
			2
		],
		"preparations": [
			1, 2, 6, 7
		],
		"pairings": [
			"almonds",
			"apple cider",
			"apples",
			"bacon",
			"basil",
			"bay leaf",
			"bread crumbs",
			"butter",
			"celery",
			"celery root",
			"cheese",
			"chestnuts",
			"chives",
			"coriander",
			"cream",
			"creme fraiche",
			"dill",
			"fennel seeds",
			"garlic",
			"hazelnuts",
			"juniper berries",
			"lemon",
			"marjoram",
			"mustard",
			"nutmeg",
			"olive oil",
			"onions",
			"pancetta",
			"paprika",
			"parsley",
			"pepper",
			"mashed potatos",
			"shallots",
			"sugar",
			"suncokes",
			"thyme",
			"turnips",
			"vermouth",
			"vinaigrette",
			"water chestnuts",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"butternut squash": {
		"name": "butternut squash",
		"seasons": [
			1,
			2,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 4
		],
		"pairings": [
			"allspice",
			"anchovies",
			"apples",
			"bacon",
			"basil",
			"bay leaf",
			"bourbon",
			"bread crumbs",
			"brown butter",
			"carrots",
			"cayenne",
			"celery",
			"celery root",
			"cheese",
			"chervil",
			"chestnuts",
			"chickpeas",
			"chile peppers",
			"chives",
			"cilantro",
			"cinnamon",
			"cloves",
			"coconut milk",
			"coriander",
			"couscous",
			"cream",
			"creme fraiche",
			"cumin",
			"curry powder",
			"duck",
			"fenugreek",
			"fish sauce",
			"garlic",
			"ginger",
			"honey",
			"leeks",
			"lemon",
			"lemongrass",
			"lime",
			"maple syrup",
			"marjoram",
			"mascarpone",
			"mint",
			"mushrooms",
			"nutmeg",
			"nuts",
			"olive oil",
			"onions",
			"orange juice",
			"pancetta",
			"parsley",
			"parsmps",
			"pears",
			"pepper",
			"pork",
			"potatoes",
			"pumpkin seeds",
			"red pepper flakes",
			"risotto",
			"rosemary",
			"sage",
			"shallots",
			"shrimp",
			"sour cream",
			"spinach",
			"tarragon",
			"thyme",
			"truffle oil",
			"vanilla",
			"vinegar",
			"sherry",
			"walnuts",
			"watercress",
			"yams",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"carrots": {
		"name": "carrots",
		"seasons": [
			6,
			7,
			8,
			9,
			10
		],
		"preparations": [
			1, 2, 4, 5, 6, 7
		],
		"pairings": [
			"allspice",
			"almonds",
			"anise",
			"apple juice",
			"bacon",
			"basil",
			"bay leaf",
			"beef",
			"brandy",
			"brown butter",
			"carrot juice",
			"celery",
			"chervil",
			"chicken",
			"chile peppers",
			"chives",
			"cilantro",
			"cinnamon",
			"cloves",
			"cod",
			"coriander",
			"cream",
			"cumin",
			"dill",
			"fennel",
			"garlic",
			"ginger",
			"hazelnut",
			"honey",
			"lamb",
			"leeks",
			"lemon juice",
			"lime juice",
			"maple syrup",
			"mustard",
			"olive oil",
			"onion",
			"orange juice",
			"parsley",
			"parsnips",
			"peas",
			"pistachios",
			"potatoes",
			"raisins",
			"beets",
			"rosemalY",
			"rum",
			"sage",
			"savory",
			"scallops",
			"shallots",
			"spinach",
			"tamarind",
			"tarragon",
			"thyme",
			"turnips",
			"veal",
			"vinaigrette",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"cauliflower": {
		"name": "cauliflower",
		"seasons": [
			8,
			9,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 5, 6, 7
		],
		"pairings": [
			"anchovies",
			"apples",
			"bay leaf",
			"bell peppers",
			"bread crumbs",
			"broccoli",
			"brown butter",
			"capers",
			"cardamom",
			"caviar",
			"cheese",
			"chervil",
			"chile peppers",
			"chives",
			"cilantro",
			"coriander",
			"cream",
			"cumin",
			"curry powder",
			"diIl",
			"garam masala",
			"garlic",
			"ginger",
			"greens",
			"leeks",
			"lemon juice",
			"lime juice",
			"mint",
			"mussels",
			"mustard",
			"nutmeg",
			"olive oil",
			"olives",
			"onions",
			"orange juice",
			"paprika",
			"parsley",
			"pine nuts",
			"poppy seeds",
			"potatoes",
			"raisins",
			"red pepper flakes",
			"saffron",
			"scallions",
			"scallops",
			"shallots",
			"tarragon",
			"thyme",
			"tomatoes",
			"truffles",
			"turmeric",
			"vinegar",
			"watercress",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"celery root": {
		"name": "celery root",
		"seasons": [
			1,
			2,
			3,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 5, 7
		],
		"pairings": [
			"allspice",
			"apples",
			"basil",
			"bay leaf",
			"beef",
			"beets",
			"brown butter",
			"capers",
			"carrots",
			"celery",
			"celery leaves",
			"cheese",
			"chervil",
			"chicken",
			"chives",
			"coriander",
			"cream",
			"creme fraiche",
			"dill",
			"fennel seeds",
			"garlic",
			"leeks",
			"lemon juice",
			"game birds",
			"garlic",
			"hazelnuts",
			"marjoram",
			"mayonnaise",
			"mushrooms",
			"mustard",
			"nutmeg",
			"olive oil",
			"olives",
			"oregano",
			"paprika",
			"parsley",
			"parsnips",
			"pecans",
			"potatoes",
			"rice",
			"rutabegas",
			"sage",
			"tarragon",
			"thyme",
			"truffles",
			"turnips",
			"veal",
			"vinaigrette",
			"watercress",
			"wild rice",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"chard": {
		"name": "chard",
		"seasons": [
			10,
			11
		],
		"preparations": [
			1, 6, 7
		],
		"pairings": [
			"anchovies",
			"bacon",
			"basil",
			"bay leaf",
			"bread crumbs",
			"butter",
			"capers",
			"cheese",
			"chickpeas",
			"chili peppers",
			"cilantro",
			"cumin",
			"cured meats",
			"garlic",
			"lamb",
			"leeks",
			"lemon juice",
			"mushrooms",
			"olive oil",
			"olives",
			"onions",
			"orange zest",
			"oragano",
			"pine nuts",
			"polenta",
			"potatoes",
			"raisins",
			"red pepper flakes",
			"saffron",
			"shallots",
			"spinach",
			"thyme",
			"tomatoes",
			"vinagar",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"cherries": {
		"name": "cherries",
		"seasons": [
			6,
			7
		],
		"preparations": [
			1, 5
		],
		"pairings": [
			"allspice",
			"almonds",
			"amaretto",
			"apricots",
			"bourbon",
			"brandy",
			"buttermilk",
			"caramel",
			"cassis",
			"cheese",
			"chocolate",
			"cloves",
			"coconut",
			"coffee",
			"cognac",
			"coriander",
			"cream",
			"cream cheese",
			"creme fraiche",
			"custards",
			"duck",
			"fennel",
			"figs",
			"game birds",
			"garlic",
			"ginger",
			"goose",
			"hazelnuts",
			"honey",
			"ice cream",
			"lemon juice",
			"lime juice",
			"mascarpone",
			"melon",
			"nectarines",
			"nuts",
			"oats",
			"orange juice",
			"pate",
			"peaches",
			"pecans",
			"pistachios",
			"plums",
			"pork",
			"port",
			"quince",
			"raspberries",
			"rose hips",
			"rum",
			"sage",
			"salads",
			"sour cream",
			"vanilla",
			"vermouth",
			"vinegar",
			"vodka",
			"walnuts",
			"wine",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"collard greens": {
		"name": "collard greens",
		"seasons": [
			1,
			2,
			11,
			12
		],
		"preparations": [
			1, 6, 7
		],
		"pairings": [
			"apple cider vinegar",
			"bacon",
			"black-eyed pease",
			"brown butter",
			"cheese",
			"garlic",
			"ham hocks",
			"mustard seeds",
			"onions",
			"oragano",
			"peanut oil",
			"red pepper flakes",
			"salt pork",
			"tomatoes",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"corn": {
		"name": "corn",
		"seasons": [
			5,
			6,
			7,
			8,
			9
		],
		"preparations": [
			1, 2, 4, 6, 7
		],
		"pairings": [
			"bacon",
			"basil",
			"bay leaf",
			"beans",
			"beef",
			"bell peppers",
			"buttermilk",
			"caraway seeds",
			"carrots",
			"cayenne",
			"celery",
			"cheese",
			"chervil",
			"chili peppers",
			"chili powder",
			"chives",
			"cilantro",
			"clams",
			"cornmeal",
			"crab",
			"cream",
			"creme fralche",
			"cumin",
			"curry powder",
			"dill",
			"eggs",
			"fava beans",
			"fennel",
			"fish",
			"garlic",
			"ginger",
			"ham",
			"leeks",
			"lemon juice",
			"lime juice",
			"lobster",
			"maple syrup",
			"marjoram",
			"mascarpone",
			"mushrooms",
			"mustard",
			"nutmeg",
			"olive oil",
			"onions",
			"oregano",
			"pancetta",
			"paprika",
			"parsley",
			"pesto",
			"polenta",
			"potatoes",
			"poultry",
			"rosemary",
			"saffron",
			"sage",
			"salmon",
			"scallions",
			"scallops",
			"shallots",
			"sherry",
			"squash",
			"star anise",
			"tarragon",
			"thyme",
			"tomatoes",
			"vermouth",
			"vinaigrette",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"cranberries": {
		"name": "cranberries",
		"seasons": [
			9,
			10,
			11,
			12
		],
		"preparations": [
			1
		],
		"pairings": [
			"allspice",
			"almonds",
			"apples",
			"apricots",
			"chicken",
			"chile peppers",
			"chocolate",
			"cinnamon",
			"cloves",
			"cognac",
			"cream",
			"cream cheese",
			"ginger",
			"goat cheese",
			"hazelnuts",
			"honey",
			"lemon juice",
			"lime juice",
			"maple syrup",
			"nuts",
			"oats",
			"orange juice",
			"peaches",
			"pears",
			"pistachios",
			"pork",
			"poultry",
			"pumpkin",
			"raisins",
			"quince",
			"star anise",
			"sweet potatoes",
			"tangerines",
			"thyme",
			"turkey",
			"vanilla",
			"walnuts",
			"white wine",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"cucumber": {
		"name": "cucumber",
		"seasons": [
			5,
			6,
			7
		],
		"preparations": [
			5
		],
		"pairings": [
			"allspice",
			"bell peppers",
			"basil",
			"butter",
			"buttermilk",
			"caraway seeds",
			"cayenne",
			"celery",
			"cheese",
			"chervil",
			"chile peppers",
			"jalapeno",
			"chives",
			"cilantro",
			"coconut milk",
			"coriander",
			"cream",
			"cream cheese",
			"creme fra1che",
			"cumin",
			"dill",
			"fish sauce",
			"frisee",
			"garlic",
			"horseradish",
			"jicama",
			"lemon",
			"lemon juice",
			"lime juice",
			"melon",
			"mint",
			"mustard",
			"olive oil",
			"onions",
			"oregano",
			"parsley",
			"peanuts",
			"pineapple",
			"red pepper flakes",
			"salmon",
			"scallions",
			"scallops",
			"vinaigrettes",
			"vodka",
			"watercress",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"eggplant": {
		"name": "eggplant",
		"seasons": [
			6,
			7,
			8
		],
		"preparations": [
			1, 2, 3, 4, 6, 7
		],
		"pairings": [
			"allspice",
			"anchovies",
			"artichokes",
			"basil",
			"bell peppers",
			"bread crumbs",
			"cabbage",
			"capers",
			"cashews",
			"cheese",
			"chickpeas",
			"chile peppers",
			"chili powder",
			"chives",
			"cilantro",
			"cinnamon",
			"coconut milk",
			"coriander",
			"cumin",
			"fennel",
			"garlic",
			"ginger",
			"honey",
			"lamb",
			"lemon juice",
			"lentils",
			"mint",
			"miso",
			"mushrooms",
			"mustard",
			"olive oil",
			"olives",
			"onions",
			"oregano",
			"paprika",
			"parsley",
			"pine nuts",
			"pomegranate",
			"prosciutto",
			"red pepper flakes",
			"rice",
			"rosemary",
			"saffron",
			"sage",
			"sausage",
			"savory",
			"scallions",
			"sesame oil",
			"shallots",
			"soy sauce",
			"squash",
			"tahini",
			"thyme",
			"tomatoes",
			"tomato sauce",
			"vinegar",
			"red wine",
			"walnuts",
			"yogurt",
			"zucchini",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"fava beans": {
		"name": "fava beans",
		"seasons": [
			5,
			6
		],
		"preparations": [
			1
		],
		"pairings": [
			"bacon",
			"basil",
			"butter",
			"cheese",
			"chili peppers",
			"chives",
			"cilantro",
			"corn",
			"cream",
			"cumin",
			"dill",
			"duck",
			"fennel",
			"fish",
			"garlic",
			"gnocchi",
			"ham",
			"lamb",
			"leeks",
			"lemon juice",
			"lentils",
			"lobster",
			"mint",
			"olive oil",
			"onions",
			"orange zest",
			"parsley",
			"peas",
			"poultry",
			"prociutto",
			"rabbit",
			"radishes",
			"rice and risotto",
			"rosemary",
			"sage",
			"savory",
			"shellfish",
			"shallots",
			"spinach",
			"thyme",
			"tomatoes",
			"vinaigrette",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"fennel": {
		"name": "fennel",
		"seasons": [
			1,
			2,
			3,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 4, 5, 6, 7
		],
		"pairings": [
			"almonds",
			"amse",
			"apples",
			"arugula",
			"asparagus",
			"basil",
			"bay leaf",
			"beets",
			"bell peppers",
			"butter",
			"carrots",
			"cheese",
			"chicken",
			"chives",
			"coriander",
			"crab",
			"cream",
			"creme fraiche",
			"cucumbers",
			"eggplant",
			"endive",
			"frisee",
			"garlic",
			"ginger",
			"honey",
			"lamb",
			"leeks",
			"lemon juice",
			"lime juicelobster",
			"mint",
			"mussels",
			"nutmeg",
			"olive oil",
			"olives",
			"onions",
			"pancetta",
			"paprika",
			"parsley",
			"pear",
			"pecans",
			"pickles",
			"pork",
			"potatoes",
			"prociutto",
			"rice",
			"rosemary",
			"salmon",
			"scallions",
			"shallots",
			"shellfish",
			"shrimp",
			"spinach",
			"star anise",
			"swordfish",
			"tarragon",
			"thyme",
			"tomatoes",
			"tuna",
			"veal",
			"vermouth",
			"vinagrettes",
			"walnuts",
			"watercress",
			"zucchini",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"figs": {
		"name": "figs",
		"seasons": [8],
		"preparations": [
			1, 2, 3, 4, 5
		],
		"pairings": [
			"almonds",
			"anchovies",
			"anise",
			"apples",
			"arugula",
			"bacon",
			"butter",
			"caramel",
			"cheese",
			"cherries",
			"chicken",
			"chocolate",
			"cilantro",
			"cinnamon",
			"cloves",
			"coffee",
			"cognac",
			"cream",
			"cream cheese",
			"creme anglaise",
			"creme fraiche",
			"duck",
			"fish",
			"game birds",
			"garlic",
			"ginger",
			"grapes",
			"ham",
			"hazelnuts",
			"honey",
			"lamb",
			"lemon juice",
			"lime juice",
			"mango",
			"mascarpone",
			"mint",
			"olive oil",
			"onions",
			"orange juice",
			"pancetta",
			"pears",
			"pecans",
			"pine nuts",
			"pistachios",
			"pork",
			"port",
			"prosciutto",
			"quail",
			"radicchio",
			"rasberries",
			"quince",
			"rosemary",
			"rum",
			"star anlse",
			"thyme",
			"vanilla",
			"vinegar",
			"walnuts",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"kale": {
		"name": "kale",
		"seasons": [
			1,
			2,
			3,
			4
		],
		"preparations": [
			1, 6, 7
		],
		"pairings": [
			"bay leaf",
			"bell peppers",
			"butter",
			"cheese",
			"cream",
			"garlic",
			"ginger",
			"lemon juice",
			"nutmeg",
			"olive oil",
			"onions",
			"oregano",
			"pancetta",
			"pork",
			"potatoes",
			"red pepper flakes",
			"sausage",
			"shallots",
			"sour cream",
			"soy sauce",
			"sugar",
			"sweet potatoes",
			"thyme",
			"tomatoes",
			"vinegar",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"kiwi fruit": {
		"name": "kiwi fruit",
		"seasons": [
			1,
			2,
			3,
			4,
			5,
			6,
			7
		],
		"preparations": [
			5
		],
		"pairings": [
			"bananas",
			"berries",
			"cherries",
			"chololate",
			"coconut",
			"cream",
			"custard",
			"grapefruit",
			"hazelnuts",
			"honey",
			"lemon juice",
			"lime juice",
			"lychee fruit",
			"macadamia nuts",
			"mangoes",
			"oranges",
			"papaya",
			"passion fruit",
			"pineapple",
			"rum",
			"strawberries",
			"wine",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"kohlrabi": {
		"name": "kohlrabi",
		"seasons": [
			6,
			7,
			8
		],
		"preparations": [
			1, 6, 7
		],
		"pairings": [
			"allspice",
			"basil",
			"butter",
			"cabbage",
			"carrots",
			"celery",
			"celery root",
			"cheese",
			"cilantro",
			"coriander",
			"cream",
			"dill",
			"fennel",
			"garlic",
			"horseradish",
			"leeks",
			"lemon juice",
			"mace",
			"mustard",
			"onions",
			"parsley",
			"potatoes",
			"rosemary",
			"sesame oil",
			"sour cream",
			"soy sauce",
			"tumeric",
			"vinegar",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"leeks": {
		"name": "leeks",
		"seasons": [
			1,
			2,
			3,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 4, 7
		],
		"pairings": [
			"anchovies",
			"bacon",
			"barley",
			"bay leaf",
			"beef",
			"butter",
			"capers",
			"caraway",
			"carrots",
			"cauliflower",
			"celery",
			"cheese",
			"chervil",
			"chile peppers",
			"coriander",
			"cream",
			"creme fraiche",
			"dill",
			"fennel",
			"fish",
			"garlic",
			"lemon juice",
			"mushrooms",
			"mussels",
			"mustard",
			"nutmeg",
			"olive oil",
			"onions",
			"oregano",
			"paprika",
			"parsley",
			"potatoes",
			"sage",
			"scallions",
			"sea bass",
			"soups",
			"soy sauce",
			"stews",
			"tarragon",
			"thyme",
			"tomatoes",
			"truffles",
			"vinaigrette",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"melon": {
		"name": "melon",
		"seasons": [
			6,
			7,
			8,
			9
		],
		"preparations": [
			5
		],
		"pairings": [
			"almonds",
			"apricots",
			"basil",
			"blackberries",
			"blueberries",
			"cherries",
			"chile peppers",
			"cilantro",
			"cognac",
			"cream",
			"creme fraiche",
			"cucumbers",
			"cured meats",
			"curry",
			"fennel",
			"ginger",
			"grapefruit",
			"grapes",
			"hazelnuts",
			"honey",
			"ice creams",
			"kiwi fruit",
			"lemon juice",
			"lime juice",
			"lychees",
			"macadamia nuts",
			"mangoes",
			"mint",
			"olive oil",
			"orange",
			"pears",
			"pecans",
			"port",
			"prosciutto",
			"raspberries",
			"rum",
			"sake",
			"strawberries",
			"terragon",
			"taquila",
			"vanilla",
			"vinegar",
			"yoghurt",
			"yuzu juice",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"oranges": {
		"name": "oranges",
		"seasons": [
			1,
			2,
			3,
			12
		],
		"preparations": [
			1, 5
		],
		"pairings": [
			"almonds",
			"apples",
			"arugula",
			"avacados",
			"bananas",
			"basil",
			"beets",
			"blackberries",
			"blueberries",
			"brandy",
			"buttermilk",
			"caramel",
			"cardamom",
			"carrots",
			"cheese",
			"cherries",
			"chestnuts",
			"chicken",
			"chili peppers",
			"chives",
			"chocolate",
			"cilantro",
			"cinnamon",
			"cloves",
			"coconut",
			"coffee",
			"cognac",
			"crab",
			"cranberries",
			"cream",
			"cumin",
			"custard",
			"dates",
			"desserts",
			"fennel",
			"figs",
			"fish",
			"garlic",
			"ginger",
			"grapefruit",
			"guava",
			"hazelnuts",
			"honey",
			"juniper berries",
			"kumquats",
			"lemon juice",
			"lemongrass",
			"lime juice",
			"macadamia nuts",
			"mangoes",
			"maple syrup",
			"mascarpone",
			"melon",
			"meringue",
			"mint",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"parsnips": {
		"name": "parsnips",
		"seasons": [
			10,
			11
		],
		"preparations": [
			1, 2, 3, 4, 7
		],
		"pairings": [
			"allspice",
			"anise",
			"apples",
			"bacon",
			"basil",
			"bay leaf",
			"beans",
			"butter",
			"carrots",
			"cheese",
			"chervil",
			"chile peppers",
			"chives",
			"cinnamon",
			"coriander",
			"cream",
			"cumin",
			"dill",
			"duck",
			"fennel",
			"fish",
			"game birds",
			"garlic",
			"ginger",
			"honey",
			"leeks",
			"lemon juice",
			"lentils",
			"mace",
			"maple syrup",
			"mint",
			"mirin",
			"mushrooms",
			"mustard",
			"nutmeg",
			"olive oil",
			"onions",
			"orange",
			"pancetta",
			"parsley",
			"pears",
			"potatoes",
			"rosemary",
			"sage",
			"shallots",
			"soy sauce",
			"tarragon",
			"thyme",
			"vinegar",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"passion fruit": {
		"name": "passion fruit",
		"seasons": [
			6,
			7
		],
		"preparations": [
			5
		],
		"pairings": [
			"almonds",
			"bananas",
			"caramel",
			"cashews",
			"chicken",
			"chives",
			"chocolate",
			"cilantro",
			"coconut",
			"cream",
			"cream cheese",
			"custard",
			"fish",
			"ginger",
			"kiwi fruit",
			"lemon juice",
			"lime juice",
			"macadamia nuts",
			"mangoes",
			"orange",
			"papayas",
			"peaches",
			"pears",
			"pineapples",
			"rum",
			"strawberries",
			"tapioca",
			"tequila",
			"vanilla",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"peaches": {
		"name": "peaches",
		"seasons": [
			7,
			8
		],
		"preparations": [
			2, 4, 5, 6
		],
		"pairings": [
			"allspice",
			"almonds",
			"apples",
			"apricots",
			"arugula",
			"basil",
			"blackberries",
			"blueberries",
			"bourbon",
			"brandy",
			"butter",
			"buttermilk",
			"caramel",
			"cherries",
			"chile peppers",
			"chocolate",
			"cinnamon",
			"cloves",
			"coconut",
			"cognac",
			"cream",
			"creme fraiche",
			"figs",
			"hazelnuts",
			"honey",
			"ice cream",
			"lavender",
			"lemon juice",
			"lime juice",
			"mace",
			"maple syrup",
			"mascarpone",
			"mint",
			"molasses",
			"nectarines",
			"nutmeg",
			"oatmeal",
			"sour cream",
			"star anise",
			"strawberries",
			"tarragon",
			"tea",
			"thyme",
			"tuna",
			"vanilla",
			"vinegar",
			"walnuts",
			"watercress",
			"whiskey",
			"wine",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"pears": {
		"name": "pears",
		"seasons": [
			9,
			10,
			11
		],
		"preparations": [
			1, 2, 4, 5, 6
		],
		"pairings": [
			"allspice",
			"almonds",
			"anise",
			"apples",
			"apricots",
			"arugula",
			"bacon",
			"basil",
			"beets",
			"blackberries",
			"blueberries",
			"bourbon",
			"brandy",
			"brown butter",
			"butterscotch",
			"caramel",
			"cardamom",
			"celery",
			"cheese",
			"cherries",
			"chestnuts",
			"chocolate",
			"cinnamon",
			"cloves",
			"cranberries",
			"cream",
			"cream cheese",
			"creme fraiche",
			"custards",
			"dates",
			"dill",
			"duck",
			"endive",
			"figs",
			"ginger",
			"hazelnuts",
			"honey",
			"macadamia nuts",
			"maple syrup",
			"mascarpone",
			"mint",
			"mustard",
			"nutmeg",
			"nuts",
			"oats",
			"olive oil",
			"onions",
			"orange",
			"parsley",
			"passion fruit",
			"peanuts",
			"pecans",
			"pine nuts",
			"pistachios",
			"pork",
			"port",
			"poultry",
			"praline",
			"prosciutto",
			"prunes",
			"quince",
			"radicchio",
			"raisins",
			"raspberries",
			"rhubarb",
			"rice",
			"rosemary",
			"rum",
			"sour cream",
			"squash",
			"star anise",
			"strawberries",
			"sweet potatoes",
			"toffee",
			"vanilla",
			"vinegar",
			"walnuts",
			"watercress",
			"whiskey",
			"wine",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"peas": {
		"name": "peas",
		"seasons": [
			5,
			6,
			7,
			8
		],
		"preparations": [
			1, 6, 7
		],
		"pairings": [
			"arugula",
			"asparagus",
			"bacon",
			"basil",
			"bay leaf",
			"butter",
			"cardamom",
			"carrots",
			"cayenne",
			"celery",
			"cheese",
			"chervil",
			"chile peppers",
			"chives",
			"cilantro",
			"coriander",
			"crab",
			"cream",
			"creme fraiche",
			"cumin",
			"curry powder",
			"dill",
			"fava beans",
			"fish",
			"garlic",
			"ginger",
			"ham",
			"honey",
			"leeks",
			"lemon juice",
			"lime juice",
			"lobster",
			"marjoram",
			"mint",
			"mushrooms",
			"oilive oil",
			"onion",
			"parsley",
			"potatoes",
			"poultry",
			"prosciutto",
			"risotto",
			"rosemary",
			"savory",
			"scallions",
			"scallops",
			"shallots",
			"shrimp",
			"snap peas",
			"spinach",
			"terragon",
			"thyme",
			"tomatoes",
			"tumeric",
			"vinagrette",
			"watercress",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"persimmon": {
		"name": "persimmon",
		"seasons": [
			11,
			12
		],
		"preparations": [
			2, 5
		],
		"pairings": [
			"almonds",
			"apples",
			"avocados",
			"bourbon",
			"brandy",
			"caramel",
			"cashews",
			"cheese",
			"chile peppers",
			"chocolate",
			"cinnamon",
			"cloves",
			"coffee",
			"cognac",
			"cream",
			"endive",
			"frisee",
			"ginger",
			"grapes",
			"hazelnuts",
			"honey",
			"kiwi fruit",
			"kumquats",
			"lemon juice",
			"mace",
			"maple syrup",
			"nutmeg",
			"oatmeal",
			"olive oil",
			"orange",
			"pears",
			"pecans",
			"pomegranates",
			"pork",
			"poultry",
			"prosciutto",
			"radicchio",
			"raisins",
			"rum",
			"sweet potatoes",
			"vanilla",
			"vinegar",
			"walnuts",
			"watercress",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"pineapple": {
		"name": "pineapple",
		"seasons": [
			3,
			4,
			5,
			6
		],
		"preparations": [
			2, 4, 5, 6
		],
		"pairings": [
			"allspice",
			"apricots",
			"avocado",
			"bananas",
			"basil",
			"brandy",
			"butter",
			"caramel",
			"cardamom",
			"cashews",
			"cayenne",
			"chile peppers",
			"chocolate",
			"cilantro",
			"cinnamon",
			"cloves",
			"coconut",
			"cognac",
			"cream",
			"fennel seeds",
			"ginger",
			"grapefruit",
			"ham",
			"honey",
			"kiwi fruit",
			"lemon juice",
			"lemongrass",
			"lime juice",
			"macadamia nuts",
			"mango",
			"maple syrup",
			"mint",
			"oilive oil",
			"oranges",
			"papaya",
			"passion fruit",
			"pistachios",
			"pomegranate",
			"poultry",
			"raspberries",
			"rice",
			"rosemary",
			"rum",
			"saffron",
			"shallots",
			"spinach",
			"star anise",
			"strawberries",
			"sweet potatoes",
			"szechuan peppercorns",
			"tamarind",
			"vanilla",
			"walnuts",
			"watercress",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"plums": {
		"name": "plums",
		"seasons": [
			6,
			7,
			8,
			9,
			10
		],
		"preparations": [
			1, 2, 5
		],
		"pairings": [
			"allspice",
			"almonds",
			"apricots",
			"arugula",
			"bay leaf",
			"brandy",
			"butter",
			"buttermilk",
			"caramel",
			"cardamom",
			"cherries",
			"cider",
			"cinnamon",
			"cloves",
			"coriander",
			"cream",
			"creme fraiche",
			"gin",
			"ginger",
			"hazelnuts",
			"honey",
			"juniper berries",
			"lavender",
			"lemon juice",
			"maple syrup",
			"mint",
			"nectarines",
			"nutmeg",
			"oatmeal",
			"olive oil",
			"oranges",
			"peaches",
			"pecans",
			"prosciutto",
			"raspberries",
			"rum",
			"sage",
			"sour cream",
			"strawberries",
			"thyme",
			"vanilla",
			"vinegar",
			"walnuts",
			"whiskey",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"pomegranate": {
		"name": "pomegranate",
		"seasons": [
			9,
			10,
			11,
			12,
			1
		],
		"preparations": [
			5
		],
		"pairings": [
			"allspice",
			"almonds",
			"arugula",
			"avocados",
			"bananas",
			"beets",
			"cardamom",
			"chile peppers",
			"chocolate",
			"cinnamon",
			"cloves",
			"coconut",
			"coriander",
			"couscous",
			"cream",
			"cucumbers",
			"cumin",
			"fish",
			"grapefruit",
			"hazelnuts",
			"honey",
			"hummus",
			"lamb",
			"lemon juice",
			"lime juice",
			"nutmeg",
			"olive oil",
			"onions",
			"orange juice",
			"parsley",
			"pine nuts",
			"pork",
			"poultry",
			"sesame seeds",
			"tequila",
			"turmeric",
			"vinegar",
			"walnuts",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"potatoes": {
		"name": "potatoes",
		"seasons": [
			1,
			2,
			3,
			9,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 4, 6, 7
		],
		"pairings": [
			"arugula",
			"bacon",
			"basil",
			"bay leaf",
			"beef",
			"bell peppers",
			"butter",
			"caraway seeds",
			"cardamom",
			"carrots",
			"caviar",
			"celery",
			"celery root",
			"cheese",
			"chervil",
			"chicory",
			"chili peppers",
			"chili oil",
			"chives",
			"cilantro",
			"coriander",
			"cream",
			"creme fraiche",
			"cumin",
			"dill",
			"garam masala",
			"garlic",
			"ginger",
			"kale",
			"lamb",
			"lavender",
			"leeks",
			"lemon juice",
			"mayonnaise",
			"mushrooms",
			"mussels",
			"mustard",
			"olive oil",
			"olives",
			"onions",
			"oysters",
			"paprika",
			"parsley",
			"parsnips",
			"peas",
			"pork",
			"ramps",
			"rosemary",
			"rutabegas",
			"saffron",
			"sage",
			"sausages",
			"savory",
			"scallions",
			"shallots",
			"sorrel",
			"sour cream",
			"spinach",
			"squash",
			"steak",
			"sweet potatoes",
			"thyme",
			"tomatoes",
			"truffles",
			"turnips",
			"vinagrettes",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"pumpkin": {
		"name": "pumpkin",
		"seasons": [
			10,
			11,
			12,
			1
		],
		"preparations": [
			1, 2, 4
		],
		"pairings": [
			"allspice",
			"apples",
			"bay leaf",
			"brandy",
			"butter",
			"caramel",
			"carrots",
			"cayenne",
			"cheese",
			"chile peppers",
			"cilantro",
			"cinnamon",
			"cloves",
			"coconut",
			"cognac",
			"cranberries",
			"cream",
			"cream cheese",
			"creme fraiche",
			"cumin",
			"duck",
			"garlic",
			"ginger",
			"hazelnuts",
			"honey",
			"kumquats",
			"lemon juice",
			"lime juice",
			"lobster",
			"mace",
			"maple syrup",
			"marjoram",
			"molasses",
			"mushrooms",
			"nutmeg",
			"nuts",
			"olive oil",
			"onions",
			"orange",
			"oysters",
			"pecans",
			"pine nuts",
			"pork",
			"potatoes",
			"pumpkin seeds",
			"radicchio",
			"raisins",
			"risotto",
			"rosemary",
			"rum",
			"sage",
			"scallops",
			"shrimp",
			"soups",
			"sour cream",
			"thyme",
			"vanilla",
			"vinegar",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"radishes": {
		"name": "radishes",
		"seasons": [
			4,
			5,
			6,
			7,
			8,
			9,
			10
		],
		"preparations": [
			5
		],
		"pairings": [
			"anchovies",
			"avocados",
			"basil",
			"butter",
			"celery",
			"cheese",
			"chervil",
			"chives",
			"cilantro",
			"crab",
			"cream",
			"cream cheese",
			"cucumbers",
			"dill",
			"fennel",
			"fish",
			"lemon juice",
			"lobster",
			"mint",
			"olive oil",
			"onions",
			"orange",
			"oregano",
			"parsley.",
			"pears",
			"pecans",
			"rosemary",
			"scallions",
			"sesame oil",
			"shallots",
			"shrimp",
			"soy sauce",
			"thyme",
			"vinaigrettes",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"raspberries": {
		"name": "raspberries",
		"seasons": [9],
		"preparations": [
			5
		],
		"pairings": [
			"almonds",
			"apricots",
			"blackberries",
			"blueberries",
			"brandy",
			"buttermilk",
			"caramel",
			"cheese",
			"chocolate",
			"cinnamon",
			"cloves",
			"cognac",
			"cream",
			"creme fraiche",
			"figs",
			"ginger",
			"graham crackers",
			"grapefruit",
			"grapes",
			"hazelnuts",
			"honey",
			"ice cream",
			"lemon juice",
			"lime juice",
			"macadamia nuts",
			"mangoes",
			"maple syrup",
			"mascarpone",
			"melon",
			"mint",
			"nectarines",
			"oatmeal",
			"orange",
			"peaches",
			"peanuts",
			"pears",
			"pecans",
			"pineapple",
			"pine nuts",
			"pistachios",
			"plums",
			"quince",
			"rhubarb",
			"rum",
			"sour cream",
			"star anise",
			"strawberries",
			"tequila",
			"vanilla",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"rhubarb": {
		"name": "rhubarb",
		"seasons": [
			4,
			5,
			6,
			7
		],
		"preparations": [
			1, 2, 6
		],
		"pairings": [
			"almonds",
			"apples",
			"bay leaf",
			"berries",
			"blood orange",
			"brandy",
			"butter",
			"buttermilk",
			"caramel",
			"cardamom",
			"cheese",
			"chives",
			"chocolate",
			"cloves",
			"cream",
			"cream cheese",
			"creme fraiche",
			"duck",
			"fennel",
			"fish",
			"foie gras",
			"game birds",
			"garlic",
			"ginger",
			"grapefruit",
			"hazelnuts",
			"honey",
			"lemon juice",
			"lime juice",
			"liver",
			"maple syrup",
			"mascarpone",
			"mint",
			"nutmeg",
			"onions",
			"orange juice",
			"pecans",
			"plums",
			"pork",
			"port",
			"raspberries",
			"sour cream",
			"strawberries",
			"trout",
			"vanilla",
			"vinegar",
			"wild rice",
			"wine",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"rutabega": {
		"name": "rutabega",
		"seasons": [
			1,
			2,
			3,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 7
		],
		"pairings": [
			"allspice",
			"apples",
			"basil",
			"bay leaf",
			"beets",
			"broccoli",
			"butter",
			"caraway seeds",
			"cardamom",
			"carrots",
			"cayenne",
			"celery",
			"celery root",
			"cheese",
			"chives",
			"cinnamon",
			"cream",
			"cream cheese",
			"cumin",
			"dill",
			"duck",
			"garlic",
			"ginger",
			"lamb",
			"leeks",
			"lemon juice",
			"mace",
			"maple syrup",
			"marjoram",
			"mustard",
			"nutmeg",
			"olive oil",
			"onions",
			"orange",
			"oregano",
			"parsley",
			"parsnips",
			"pears",
			"pork",
			"potatoes",
			"rabbit",
			"rosemary",
			"saffron",
			"sage",
			"savory",
			"scallions",
			"squash",
			"star anise",
			"sweet potatoes",
			"tarragon",
			"thyme",
			"tomatoes",
			"tuna",
			"turnips",
			"vanilla",
			"vinaIgrette",
			"watercress",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"spinach": {
		"name": "spinach",
		"seasons": [
			5,
			6,
			10,
			11
		],
		"preparations": [
			1, 5, 6, 7
		],
		"pairings": [
			"almonds",
			"anchovies",
			"apples",
			"bacon",
			"basil",
			"butter",
			"cayenne",
			"chard",
			"cheese",
			"chickpeas",
			"chives",
			"collard greens",
			"crab",
			"cream",
			"cream cheese",
			"creme fraiche",
			"cumin",
			"dill",
			"fennel",
			"fish",
			"garlic",
			"ginger",
			"lamb",
			"lemon juice",
			"lentils",
			"marjoram",
			"mascarpone",
			"mint",
			"mushrooms",
			"mustard",
			"mustard seeds",
			"nutmeg",
			"olive oil",
			"onions",
			"pancetta",
			"paprika",
			"parsley",
			"pecans",
			"pesto",
			"pine nuts",
			"potatoes",
			"prosciutto",
			"quince",
			"red pepper flakes",
			"saffron",
			"scallions",
			"sesame seeds",
			"shallots",
			"shrimp",
			"smoked salmon",
			"sorrel",
			"sour cream",
			"soy sauce",
			"thyme",
			"tomatoes",
			"tuna",
			"vinaigrette",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"strawberries": {
		"name": "strawberries",
		"seasons": [
			5,
			6,
			7
		],
		"preparations": [
			5, 6
		],
		"pairings": [
			"almonds",
			"apricots",
			"bananas",
			"berries",
			"blackberries",
			"blueberries",
			"brandy",
			"buttermilk",
			"caramel",
			"cardamom",
			"cheese",
			"chocolate",
			"cinnamon",
			"cloves",
			"cognac",
			"coriander",
			"cream",
			"cream cheese",
			"creme fraiche",
			"elderflower syrup",
			"ginger",
			"gooseberries",
			"grapefruit",
			"grapes",
			"guava",
			"hazelnuts",
			"honey",
			"kumquats",
			"lemon juice",
			"lime juice",
			"mangoes",
			"maple syrup",
			"mascarpone",
			"melon",
			"mint",
			"nutmeg",
			"oatmeal",
			"orange",
			"papaya",
			"passion fruit",
			"peaches",
			"peanuts",
			"pecans",
			"pineapple",
			"pine nuts",
			"pistachios",
			"plums",
			"pomegranates",
			"sherry",
			"shortcake",
			"sour cream",
			"vanilla",
			"vinegar",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 1
	},
	"sunchokes": {
		"name": "sunchokes",
		"seasons": [
			1,
			2,
			3,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 6
		],
		"pairings": [
			"anise",
			"bacon",
			"bay leaf",
			"butter",
			"celery",
			"cheese",
			"chervil",
			"chives",
			"coriander",
			"cream",
			"cumin",
			"dill",
			"fennel",
			"garlic",
			"ginger",
			"hazelnuts",
			"leeks",
			"lemon juice",
			"mace",
			"mushrooms",
			"nutmeg",
			"olive oil",
			"onions",
			"parsley",
			"potatoes",
			"rosemary",
			"sage",
			"salmon",
			"shallots",
			"tarragon",
			"thyme",
			"vinegar",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"sweet potatoes": {
		"name": "sweet potatoes",
		"seasons": [
			1,
			8,
			9,
			10,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 4, 6, 7
		],
		"pairings": [
			"allspice",
			"anise",
			"apples",
			"bacon",
			"basil",
			"bay leaf",
			"beans",
			"bell peppers",
			"bourbon",
			"brandy",
			"butter",
			"caramel",
			"cheese",
			"chestnuts",
			"chile peppers",
			"chives",
			"cilantro",
			"cinnamon",
			"cloves",
			"coconut",
			"coriander",
			"cranberries",
			"cream",
			"creme fra iche",
			"cumin",
			"curry powder",
			"dates",
			"dill",
			"duck",
			"figs",
			"garlic",
			"ginger",
			"ham",
			"hazelnuts",
			"honey",
			"kale",
			"ketchup",
			"leeks",
			"lemon juice",
			"lime juice",
			"maple syrup",
			"molasses",
			"mushrooms",
			"mustard",
			"nutmeg",
			"oatmeal",
			"olive oil",
			"onions",
			"orange",
			"paprika",
			"parsley",
			"peanuts",
			"pears",
			"pecans",
			"persimmons",
			"pineapple",
			"pork",
			"potatoes",
			"poultry",
			"prosciutto",
			"pumpkin",
			"pumpkin seeds",
			"raisins",
			"red pepper flakes",
			"rosemary",
			"rum",
			"sage",
			"sausage",
			"sesame seeds",
			"sour cream",
			"tarragon",
			"thyme",
			"tomatoes",
			"vanilla",
			"vinegar",
			"walnuts",
			"whiskey",
			"worcestershire sauce",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"tomatoes": {
		"name": "tomatoes",
		"seasons": [
			6,
			7,
			8,
			9
		],
		"preparations": [
			2, 3, 4, 5, 6
		],
		"pairings": [
			"aioli",
			"allspice",
			"almonds",
			"anchovies",
			"arugula",
			"avocados",
			"beets",
			"bell peppers",
			"broccoli",
			"butter",
			"capers",
			"carrots",
			"cauliflower",
			"cayenne",
			"cheese",
			"chervil",
			"chickpeas",
			"chile peppers",
			"chives",
			"cilantro",
			"cinnamon",
			"coconut milk",
			"coriander",
			"corn",
			"crab",
			"cream",
			"cream cheese",
			"cucumbers",
			"cumin",
			"dill",
			"eggplant",
			"fennel",
			"fish",
			"garlic",
			"ginger",
			"ham",
			"hazelnuts",
			"honey",
			"horseradish",
			"lamb",
			"lavender",
			"leeks",
			"lemon juice",
			"lime juice",
			"mango",
			"marjoram",
			"mayonnaise",
			"melon",
			"mint",
			"mushrooms",
			"mustard",
			"okra",
			"olive oil",
			"olives",
			"onions",
			"orange",
			"oregano",
			"paprika",
			"parsley",
			"peas",
			"pineapple",
			"port",
			"raspberries",
			"red pepper flakes",
			"rice",
			"rosemary",
			"saffron",
			"sage",
			"shallots",
			"shellfish",
			"soups",
			"squash",
			"strawberries",
			"tarragon",
			"thyme",
			"vinegar",
			"watermelon",
			"yogurt",
			"zucchini",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"turnips": {
		"name": "turnips",
		"seasons": [
			1,
			2,
			3,
			4,
			11,
			12
		],
		"preparations": [
			1, 2, 3, 7
		],
		"pairings": [
			"bacon",
			"bay leaf",
			"butter",
			"carrots",
			"celery root",
			"cheese",
			"cream",
			"dill",
			"duck",
			"garlic",
			"honey",
			"juniper berries",
			"lamb",
			"leeks",
			"lemon juice",
			"marjoram",
			"nutmeg",
			"onions",
			"parsley",
			"poppy seeds",
			"pork",
			"potatoes",
			"prosciutto",
			"sweet potatoesthyme",
			"vinegar",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"wild mushrooms": {
		"name": "wild mushrooms",
		"seasons": [
			9,
			10,
			11
		],
		"preparations": [
			2, 3, 4, 6, 7
		],
		"pairings": [
			"almonds",
			"asparagus",
			"bacon",
			"barley",
			"basil",
			"bay leaf",
			"beans",
			"beef",
			"bell peppers",
			"butter",
			"capers",
			"carrots",
			"cayenne",
			"celery",
			"cheese",
			"chestnuts",
			"chile peppers",
			"chives",
			"cilantro",
			"cloves",
			"cognac",
			"conander",
			"crab",
			"cream",
			"creme fraiche",
			"cumin",
			"dill",
			"fennel",
			"garam masala",
			"garlic",
			"ginger",
			"ham",
			"juniper berries",
			"leeks",
			"lemon juice",
			"madeira",
			"marjoram",
			"mustard",
			"nutmeg",
			"olive oil",
			"onions",
			"oregano",
			"paprika",
			"parsley",
			"peas",
			"pine nuts",
			"pork",
			"potatoes",
			"poultry",
			"prosciutto",
			"radicchio",
			"rice",
			"risotto",
			"rosemary",
			"sage",
			"sake",
			"scallions",
			"seafood",
			"sesame oil",
			"shallots",
			"sherry",
			"sour cream",
			"soy sauce",
			"spinach",
			"tarragon",
			"thyme",
			"tomatoes",
			"truffle oil",
			"vinegar",
			"walnuts",
			"wine",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	},
	"zucchini": {
		"name": "zucchini",
		"seasons": [
			5,
			6,
			7,
			8
		],
		"preparations": [
			2, 3, 4, 6
		],
		"pairings": [
			"basil",
			"bell peppers",
			"butter",
			"cheese",
			"chili peppers",
			"chives",
			"cilantro",
			"cinnamon",
			"coriander",
			"corn",
			"cream",
			"dill",
			"eggplant",
			"fish",
			"garlic",
			"lemon juice",
			"marjoram",
			"mint",
			"mustard seeds",
			"olive oil",
			"olives",
			"onions",
			"oregano",
			"parsley",
			"pecans",
			"pesto",
			"pine nuts",
			"red pepper flakes",
			"risotto",
			"rosemary",
			"saffron",
			"sage",
			"salmon",
			"sasusage",
			"scallions",
			"scallops",
			"sesame seeds",
			"shallots",
			"shrimp",
			"sour cream",
			"terragon",
			"thyme",
			"tomatoes",
			"vinegar",
			"walnuts",
			"yogurt",
			""
		],
		"good pairings": null,
		"great pairings": null,
		"isFruit": 0
	}
}

export default Produce;
